import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import LoginPageViewNew from "views/login/LoginPageViewNew";

//"controllers/signup/SignUpController",
//"controllers/signup/FullSignUpController",
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import { INLINE_AUTH_MODES } from "models/helper/InlineAuthModes";
import { AUTH_SURFACE_PAGE_IDS, isAuthSurfacePageId } from "models/helper/SignupFlowHelper";
import Utils from "models/helper/Utils";

import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import SignUpController from 'controllers/signup/SignUpController';

//"controllers/featurePage/FeaturePageController",
import FacebookHelper from "models/helper/FacebookHelper";
import PersistentModels from "services/PersistentModels";
import FacebookEventTrackingHelper from "models/helper/FacebookEventTrackingHelper";
import ti18n from "i18n!nls/loginPagei18n";
import GooglePlusHelper from "models/helper/GooglePlusHelper";
import AppleIDHelper from "models/helper/AppleIDHelper";
import SignupIntentHelper from "models/helper/SignupIntentHelper";
import RSVP from "rsvp";
import ExpectedError from "models/helper/ExpectedError";
const DISABLE_FEATURE_PAGE = !window.enableFeatureDisplayBeforeLogin;
let BUILT_IN_ACCESS_CODE_FOR_LISTENERS = "7B2-DXWC-EMP1";
//const BUILT_IN_ACCESS_CODE_FOR_LISTENERS = "SAMS-UNG-KKGE";
if(!window.waitForCordovaToLoad){
    BUILT_IN_ACCESS_CODE_FOR_LISTENERS = "WEBB-58D2-V8V"
}
const LoginController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this.onLoginSuccessfullyCompleted =  options? options.onLoginSuccessfullyCompleted:null;
        this.loginApi =  options? options.loginApi:null;
        this.startMagicAuthApi = options? options.startMagicAuthApi:null;
        this.verifyMagicAuthApi = options? options.verifyMagicAuthApi:null;
        this.verifyEmailVerificationApi = options? options.verifyEmailVerificationApi:null;
        this.startOrganizationLoginApi = options ? options.startOrganizationLoginApi : null;
        this.loginWithFacebookApi =  options? options.loginWithFacebookApi:null;
        this.loginWithGoogleApi =  options? options.loginWithGoogleApi:null;
        this.loginWithAppleApi =  options? options.loginWithAppleApi:null;
        this.showAsPopup = options? options.showAsPopup:null;
        this.loginAsGuestApi=  options? options.loginAsGuestApi:null;
        this.signupApi =  options? options.signupApi:null;
        this.signupWithFacebookApi =  options? options.signupWithFacebookApi:null;
        this.signupWithGoogleApi =  options? options.signupWithGoogleApi:null;
        this.signupWithAppleApi =  options? options.signupWithAppleApi:null;
        this.doNotAllowGuestLogin = options? options.doNotAllowGuestLogin : false;
        this.forceSignUpAsCreator =  options? options.forceSignUpAsCreator: false;
        this._successSignupData =  options? options.successSignupData : null;
        this.isUserpreviouslyLoggedInAsGuest =  false;//THIS IS FOR TEMPORARY USAGE AND SHOULD BE REMOVED LATER//options? options.isUserpreviouslyLoggedInAsGuest : false;
        this._signupPageOpened = false;
        this._pendingInlineAuthChallenge = null;
        this._skipLoginCancellationOnNextViewRemoval = false;
    },

    _trackSuccessfulLogin: function(method) {
        try {
            FacebookEventTrackingHelper.getInstance().trackUserLogin(method);
        } catch(trackingError) {
            console.warn('Failed to track user login:', trackingError);
        }
    },

    setDoNotAllowGuestLogin : function(doNotAllowGuestLogin){
        this.doNotAllowGuestLogin = !!doNotAllowGuestLogin;
        if(this.view && this.view.setDoNotAllowGuestLogin){
            this.view.setDoNotAllowGuestLogin(this.doNotAllowGuestLogin);
        }
    },

    _completeHostedAuthentication : function(loginMethod, loginResult, options){
        if(loginResult === false){
            return RSVP.Promise.reject(window.getI18n(ti18n, "LOGIN_FAILED"));
        }

        LocalStorageHelper.getInstance().setUsingNewLoginModule();
        if(loginMethod){
            this._trackSuccessfulLogin(loginMethod);
        }

        const resolvedLoginResult = loginResult === undefined || loginResult === null ? true : loginResult;
        return this._finalizeSuccessfulAuthentication(resolvedLoginResult, options);
    },

    _completeCordovaHostedLogin : function(loginMethod, loginResult, options){
        if(!window.waitForCordovaToLoad){
            return RSVP.Promise.resolve(loginResult);
        }

        return this._completeHostedAuthentication(loginMethod, loginResult, options);
    },

    _completeBrowserHostedPopupLogin : function(loginMethod, loginResult, options){
        if(!Utils.getInstance().isBrowserHostedAuthEnvironment() || !this.showAsPopup){
            return RSVP.Promise.resolve(loginResult);
        }

        return this._completeHostedAuthentication(loginMethod, loginResult, options);
    },

    _runLoginSuccessCallback: function(loginResult){
        if(!this.onLoginSuccessfullyCompleted){
            return RSVP.Promise.resolve(loginResult);
        }

        return RSVP.Promise.resolve(this.onLoginSuccessfullyCompleted(loginResult)).then(function(){
            return loginResult;
        });
    },

    _finalizeSuccessfulAuthentication: function(loginResult, options){
        const resolvedOptions = Object.assign({
            closeInlineAuthFlow: false,
            treatAsSignupCompletion: false,
        }, options || {});
        const loginViewPageId =
            this.view && this.view.$el && this.view.$el.length && this.view.$el.attr ?
                this.view.$el.attr("id") :
                null;

        return this._runLoginSuccessCallback(loginResult).then((function(){
            if(resolvedOptions.closeInlineAuthFlow && this.view){
                this.view.closeInlineAuthFlow();
            }

            const router = PersistentModels.getInstance().getRouter ? PersistentModels.getInstance().getRouter() : null;
            const closePopupIfNeeded = (function(){
                if(!this.showAsPopup || !this.view || !this.view.close){
                    return RSVP.Promise.resolve();
                }

                this._skipLoginCancellationOnNextViewRemoval = true;
                return RSVP.Promise.resolve(this.view.close());
            }).bind(this);

            // Signup-completion flows (login-wall signups, post-signup inline
            // login) must reach the dedicated welcome handler even if the
            // caller's onLoginSuccessfullyCompleted already navigated away
            // from #NewLoginPage. Run this BEFORE the "has navigation moved?"
            // bailout below, otherwise activePageId !== loginViewPageId and
            // the guard returns without invoking showDefaultPageAfterSignup.
            if(resolvedOptions.treatAsSignupCompletion && router && router.showDefaultPageAfterSignup){
                return closePopupIfNeeded().then((function(){
                    return router.showDefaultPageAfterSignup(true);
                }).bind(this));
            }

            if(this.showAsPopup){
                return closePopupIfNeeded();
            }

            const activePageId = $(".ui-page-active").attr("id");
            const isActivePageAnotherAuthSurface = isAuthSurfacePageId(activePageId);
            if(loginViewPageId && activePageId && activePageId !== loginViewPageId && !isActivePageAnotherAuthSurface){
                return;
            }

            if($.mobile.navigate.history.activeIndex > 0){
                $.mobile.back();
                return;
            }

            if(!this.onLoginSuccessfullyCompleted){
                if(router && router.showDefaultPage){
                    return router.showDefaultPage(true);
                }
            }
        }).bind(this));
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    doLoginViaFacebookPopupWindow : function(){

        return FacebookHelper.getInstance().login();
    },

    doLoginViaApplePopupWindow : function(){				
        return AppleIDHelper.getInstance().login();
    },

    startOrganizationLogin : function(loginIdentifier){
        const resolvedLoginIdentifier = loginIdentifier && loginIdentifier.username ? loginIdentifier.username : loginIdentifier;
        if(typeof this.startOrganizationLoginApi !== "function"){
            const expectedError = new ExpectedError(
                window.getI18n(ti18n, "SOMETHING_WENT_WRONG"),
                { i18nKey: "SOMETHING_WENT_WRONG", classification: "auth" }
            );
            window.alertUserErrorMessage(expectedError);
            return RSVP.Promise.resolve(false);
        }
        if(!this.validateEmail(resolvedLoginIdentifier)){
            window.alertUserErrorMessage(window.getI18n(ti18n, "ORGANIZATION_LOGIN_REQUIRES_WORK_EMAIL"));
            return RSVP.Promise.resolve(false);
        }
        $.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        return this.startOrganizationLoginApi(resolvedLoginIdentifier ? resolvedLoginIdentifier.trim() : null).then((function(loginResult){
            return this._completeBrowserHostedPopupLogin("organization_sso", loginResult, {
                closeInlineAuthFlow: true,
            }).then((function(resolvedLoginResult){
                return this._completeCordovaHostedLogin("organization_sso", resolvedLoginResult, {
                    closeInlineAuthFlow: true,
                });
            }).bind(this));
        }).bind(this)).catch((function(error){
            window.alertUserErrorMessage(error);
        }).bind(this)).finally((function(){
            $.mobile.loading("hide");
        }).bind(this));
    },

    doLoginWithFacebook : function(facebookAccessToken){
        if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithFacebookApi(facebookAccessToken).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        if(window.waitForCordovaToLoad){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithFacebookApi(facebookAccessToken).then((function(loginResult){
                return this._completeCordovaHostedLogin('facebook', loginResult);
            }).bind(this)).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        $.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        let facebookAuthRetrivedInfo = null;
        let loginErrorMessage =  null;
        const getAccessTokenPromise = facebookAccessToken? RSVP.Promise.resolve({"accessToken":facebookAccessToken}):this.doLoginViaFacebookPopupWindow();
        return getAccessTokenPromise.then((function(facebookAuthInfo){
            if(facebookAuthInfo){
                facebookAuthRetrivedInfo = facebookAuthInfo;
                return this.loginWithFacebookApi(facebookAuthInfo.accessToken).catch((function(error){
                    loginErrorMessage =  error;
                    return false;
                }).bind(this));
            }else{
                throw window.getI18n(ti18n, "PLEASE_LOGIN_WITH_FACEBOOK_ACCOUNT");
            }
        }).bind(this)).then((function(loginSuccessfull){
            const p = loginSuccessfull? RSVP.Promise.resolve(): this.tryToSilentlySignupUserWithFacebookInfoThenLoginAgain(facebookAuthRetrivedInfo, loginErrorMessage);
            return p.then((function(){
                LocalStorageHelper.getInstance().setUsingNewLoginModule();
                // Track successful login for SaaS tracking
                this._trackSuccessfulLogin('facebook');
                return this._finalizeSuccessfulAuthentication(true);
            }).bind(this));
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            const onPopupClose = (function(buttonIndex){
                if(buttonIndex == 2){
                    this.showSignup();
                }
            }).bind(this);
            window.showConfirmDialog(error, onPopupClose, "Login Failure", [ window.getI18n(ti18n, "OK"), window.getI18n(ti18n, "CREATE_NEW_ACCOUNT_BUTTON_LABEL")]);
        }).bind(this));
    },

    doLoginWithApple : function(appleAccessToken){
        if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithAppleApi(appleAccessToken).then((function(loginResult){
                return this._completeBrowserHostedPopupLogin("apple", loginResult);
            }).bind(this)).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        if(window.waitForCordovaToLoad){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithAppleApi(appleAccessToken).then((function(loginResult){
                return this._completeCordovaHostedLogin('apple', loginResult);
            }).bind(this)).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        //$.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        let appleAuthRetrivedInfo = null;
        let loginErrorMessage =  null;
        const getAccessTokenPromise = appleAccessToken?RSVP.Promise.resolve({"authorization":{"id_token":appleAccessToken}}): this.doLoginViaApplePopupWindow();
        return getAccessTokenPromise.then((function(appleAuthInfo){
            if(appleAuthInfo && appleAuthInfo.authorization){
                appleAuthRetrivedInfo = appleAuthInfo;
                return this.loginWithAppleApi(appleAuthInfo.authorization.id_token).catch((function(error){
                    loginErrorMessage =  error;
                    return false;
                }).bind(this));
            }else{
                throw window.getI18n(ti18n, "PLEASE_LOGIN_WITH_APPLE_ACCOUNT");
            }
        }).bind(this)).then((function(loginSuccessfull){
            const p = loginSuccessfull? RSVP.Promise.resolve(): this.tryToSilentlySignupUserWithAppleInfoThenLoginAgain(appleAuthRetrivedInfo, loginErrorMessage);
            return p.then((function(){
                LocalStorageHelper.getInstance().setUsingNewLoginModule();
                // Track successful login for SaaS tracking
                this._trackSuccessfulLogin('apple');
                return this._finalizeSuccessfulAuthentication(true);
            }).bind(this));
        }).bind(this)).then((function(){
            //$.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            //$.mobile.loading("hide");
            const onPopupClose = (function(buttonIndex){
                if(buttonIndex == 2){
                    this.showSignup();
                }
            }).bind(this);
            console.error(error);
            const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
            const isExpectedLoginError = !!(
                error &&
                typeof(error) === "object" &&
                (
                    error.name === "ExpectedError" ||
                    error.classification === "auth" ||
                    error.i18nKey ||
                    error.statusCode
                )
            );
            let shouldSuggestAccountCreation = true;
            if(resolvedErrorMessage && (typeof(error) == "string" || isExpectedLoginError)){
                error = resolvedErrorMessage;
            }else if(typeof(error) != "string"){
                error = window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_APPLE_ACCOUNT");
                shouldSuggestAccountCreation = false;
            }

            if(error ===  window.getI18n(ti18n, "USER_CANCELLED_LOGIN_WITH_APPLE") || error ===  window.getI18n(ti18n, "USER_CLOSE_APPLE_LOGIN_POPUP")){
                shouldSuggestAccountCreation = false;
            }
            if(shouldSuggestAccountCreation){
                window.showConfirmDialog(error, onPopupClose, "Login Failure", [ window.getI18n(ti18n, "OK"), window.getI18n(ti18n, "CREATE_NEW_ACCOUNT_BUTTON_LABEL")]);
            }else{
                window.alertUserErrorMessage(error);
            }
        }).bind(this));
    },

    doLoginWithGoogle : function(googleUser){
        if(Utils.getInstance().isBrowserHostedAuthEnvironment()){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithGoogleApi(googleUser ? googleUser.getAuthResponse().id_token : null).then((function(loginResult){
                return this._completeBrowserHostedPopupLogin("google", loginResult);
            }).bind(this)).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        if(window.waitForCordovaToLoad){
            $.mobile.loading("show");
            if(this.view){
                this.view.setRemoveOnHide(true);
            }
            return this.loginWithGoogleApi(googleUser ? googleUser.getAuthResponse().id_token : null).then((function(loginResult){
                return this._completeCordovaHostedLogin('google', loginResult);
            }).bind(this)).catch((function(error){
                window.alertUserErrorMessage(error);
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        $.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        let loginErrorMessage = null;
        const getAccessTokenPromise =  RSVP.Promise.resolve(googleUser.getAuthResponse())
        return getAccessTokenPromise.then((function(googleAuthInfo){
            return this.loginWithGoogleApi(googleAuthInfo.id_token).catch((function(error){
                loginErrorMessage = error;
                return false;
            }).bind(this));
        }).bind(this)).then((function(loginSuccessfull){
            const p = loginSuccessfull? RSVP.Promise.resolve(): this.tryToSilentlySignupUserWithGoogleInfoThenLoginAgain(googleUser, loginErrorMessage);
            return p.then((function(){
                LocalStorageHelper.getInstance().setUsingNewLoginModule();
                // Track successful login for SaaS tracking
                this._trackSuccessfulLogin('google');
                return this._finalizeSuccessfulAuthentication(true);
            }).bind(this));
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            const onPopupClose = (function(buttonIndex){
                if(buttonIndex == 2){
                    this.showSignup();
                }
            }).bind(this);
            window.showConfirmDialog(error, onPopupClose, "Login Failure", [window.getI18n(ti18n, "OK"), window.getI18n(ti18n, "CREATE_NEW_ACCOUNT_BUTTON_LABEL")]);
        }).bind(this));
    },
    createUserAccountOnLoginIfUserDoesntExist : function(){
        return this.forceSignUpAsCreator || window.trebble.allowEasySignupForListenersAtLogin || window.waitForCordovaToLoad || (window.trebble.presetAccessCode && window.trebble.presetAccessCode != BUILT_IN_ACCESS_CODE_FOR_LISTENERS) || $("body").hasClass("embedded") || window.trebble.entryPointUrlHashLoadedPlayerQueue || window.trebble.isEmbededLoginInPage;
    },


    isUserNotAllowedToSignupAsCreator : function(){
        return window.waitForCordovaToLoad || $("body").hasClass("embedded") || window.trebble.entryPointUrlHashLoadedPlayerQueue || window.trebble.isEmbededLoginInPage;
    },

    _getSignupFlowDefaultIntent : function(){
        return this.forceSignUpAsCreator ?
            SignupIntentHelper.SIGNUP_INTENTS.SHORTCAST_CREATOR :
            SignupIntentHelper.getDefaultSignupIntentForCurrentSurface();
    },

    _getAutomaticSocialSignupPayload : function(){
        const presetAccessCode = window.trebble && window.trebble.presetAccessCode ? window.trebble.presetAccessCode : null;
        const defaultSignupIntent = this._getSignupFlowDefaultIntent();

        return SignupIntentHelper.normalizeSignupPayload({
            accessCode: presetAccessCode || BUILT_IN_ACCESS_CODE_FOR_LISTENERS,
        }, {
            defaultSignupIntent: defaultSignupIntent,
        });
    },

    onGoogleLoginFailed : function(error){
        //window.alertErrorMessage("Please login with your Google account.");

        if(window.waitForCordovaToLoad){
            if(GooglePlusHelper.getInstance().SIGN_IN_CANCELLED == parseInt(error)){
                //do not show error message
                return
            }else{
                if(GooglePlusHelper.getInstance().getErrorCodes().SIGN_IN_FAILED == parseInt(error)){
                    return window.alertErrorMessage(window.getI18n(ti18n, "LOGIN_FAILED"));
                }
                if(GooglePlusHelper.getInstance().getErrorCodes().SIGN_IN_REQUIRED == parseInt(error)){
                    return window.alertErrorMessage(window.getI18n(ti18n, "YOU_NEED_TO_BE_SIGN_IN_FIRST"));
                }
                if(GooglePlusHelper.getInstance().getErrorCodes().INTERNAL_ERROR == parseInt(error)){
                    return window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_GOOGLE_ACCOUNT"));
                }
                if(GooglePlusHelper.getInstance().getErrorCodes().NETWORK_ERROR == parseInt(error)){
                    return window.alertErrorMessage(window.getI18n(ti18n, "WE_COULDNT_COMPLETE_THE_LOGIN_PLEASE_CHECK_YOUR_INTERNET_CONNECTION"));
                }
                return window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_GOOGLE_ACCOUNT"));
            }
        }else{
            const onPopupClose = (function(buttonIndex){
                if(buttonIndex == 2){
                    this.showSignup();
                }
            }).bind(this);
            window.showConfirmDialog(window.getI18n(ti18n, "PLEASE_LOGIN_WITH_GOOGLE_ACCOUNT"), onPopupClose, "Login Failure", [ window.getI18n(ti18n, "OK"), window.getI18n(ti18n, "CREATE_NEW_ACCOUNT_BUTTON_LABEL")]);
        }
    },

    tryToSilentlySignupUserWithFacebookInfoThenLoginAgain : function(facebookAuthInfo, loginErrorMessage){
        if(facebookAuthInfo && this.createUserAccountOnLoginIfUserDoesntExist()){
            const signupPayload = this._getAutomaticSocialSignupPayload();
            //Try to sign up the user automatically assuming since there is no extra field to fill
            return this.signupWithFacebookApi(facebookAuthInfo.accessToken, signupPayload.accessCode, signupPayload.context || null, null, null, null,null, null, null, null, null, signupPayload.profileType || null).then((function(operationResult){
                if(operationResult && operationResult.userCreated){
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
                    } 
                    FacebookEventTrackingHelper.getInstance().trackRegistration(false, false, signupPayload.accessCode);
                }else{
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed", null, {"loginError": loginErrorMessage});
                    } 
                    if(operationResult.userAlreadyExist){
                        //User with this Facebook account already exist so try to login again
                    }else{
                        if(operationResult.emailAlreadyUsed){
                            throw (window.getI18n(ti18n, "FACEBOOK_ACCOUNT_IS_CURRENTLY_USED"))
                        }
                    }
                    throw window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_FACEBOOK_ACCOUNT");
                }
            }).bind(this)).then((function(){
                window.trebble.accountSignupHasOccuredInSession = true;
                return this.loginWithFacebookApi(facebookAuthInfo.accessToken);
            }).bind(this));
        }else{
            //throw an error
            throw loginErrorMessage? loginErrorMessage: window.getI18n(ti18n, "LOGIN_FAILED");
        }

    },

    tryToSilentlySignupUserWithGoogleInfoThenLoginAgain : function(googleUser, loginErrorMessage){
        if(googleUser && this.createUserAccountOnLoginIfUserDoesntExist()){
            const signupPayload = this._getAutomaticSocialSignupPayload();
            //Try to sign up the user automatically assuming since there is no extra field to fill

            return this.signupWithGoogleApi(googleUser.getAuthResponse().id_token, signupPayload.accessCode, signupPayload.context || null, null, null, null,null, null, null, null, null, signupPayload.profileType || null).then((function(operationResult){
                if(operationResult && operationResult.userCreated){
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
                    } 
                    FacebookEventTrackingHelper.getInstance().trackRegistration(false, false, signupPayload.accessCode);
                }else{
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed", null, {"signupError": loginErrorMessage});
                    } 
                    if(operationResult.userAlreadyExist){
                        //User with this Google account already exist so try to login again
                    }else{
                        if(operationResult.emailAlreadyUsed){
                            throw (window.getI18n(ti18n, "GOOGLE_ACCOUNT_IS_CURRENTLY_USED"))
                        }
                    }
                    throw window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_GOOGLE_ACCOUNT");
                }
            }).bind(this)).then((function(){
                window.trebble.accountSignupHasOccuredInSession = true;
                return this.loginWithGoogleApi(googleUser.getAuthResponse().id_token);
            }).bind(this));

        }else{
            //throw an error
            throw loginErrorMessage? loginErrorMessage: window.getI18n(ti18n, "LOGIN_FAILED");
        }

    },

    tryToSilentlySignupUserWithAppleInfoThenLoginAgain : function(appleAuthInfo, loginErrorMessage){
        if(appleAuthInfo && appleAuthInfo.authorization && this.createUserAccountOnLoginIfUserDoesntExist()){
            const signupPayload = this._getAutomaticSocialSignupPayload();
            //Try to sign up the user automatically assuming since there is no extra field to fill
            return this.signupWithAppleApi(appleAuthInfo.authorization.id_token, signupPayload.accessCode, signupPayload.context || null, null, null, null,null, null, null, null, null, signupPayload.profileType || null).then((function(operationResult){
                if(operationResult && operationResult.userCreated){
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompleted", "Sign-up Completed");
                    } 
                    FacebookEventTrackingHelper.getInstance().trackRegistration(false, false, signupPayload.accessCode);
                }else{
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupFailed", "Sign-up Failed", null, {"loginError": loginErrorMessage});
                    } 
                    if(operationResult.userAlreadyExist){
                        //User with this Facebook account already exist so try to login again
                    }else{
                        if(operationResult.emailAlreadyUsed){
                            throw (window.getI18n(ti18n, "APPLE_ACCOUNT_IS_CURRENTLY_USED"))
                        }
                    }
                    throw window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_CREATING_APPLE_ACCOUNT");
                }
            }).bind(this)).then((function(){
                window.trebble.accountSignupHasOccuredInSession = true;
                return this.loginWithAppleApi(appleAuthInfo.authorization.id_token);
            }).bind(this));
        }else{
            //throw an error
            throw loginErrorMessage? loginErrorMessage: window.getI18n(ti18n, "LOGIN_FAILED");
        }

    },

    doLogin : function(data){
        $.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        return this.loginApi(data.username, data.password).then((function(loginSuccessfull){
            if(loginSuccessfull && loginSuccessfull.requiresEmailVerification){
                return this._promptForPendingEmailVerification(loginSuccessfull);
            }
            if(loginSuccessfull){
                return true;
            }else{
                throw window.getI18n(ti18n, "LOGIN_FAILED");
            }
        }).bind(this)).then((function(){
            LocalStorageHelper.getInstance().setUsingNewLoginModule();
            // Track successful login for SaaS tracking
            this._trackSuccessfulLogin('email');
            return this._finalizeSuccessfulAuthentication(true);
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            if(error !== "handled"){
                window.alertErrorMessage(error);
            }
        }).bind(this));
    },

    _getStartMagicAuthApi : function(){
        if(this.startMagicAuthApi){
            return this.startMagicAuthApi;
        }
        return TrebbleClientAPIHelper.getInstance().startMagicAuth.bind(TrebbleClientAPIHelper.getInstance());
    },

    _getVerifyMagicAuthApi : function(){
        if(this.verifyMagicAuthApi){
            return this.verifyMagicAuthApi;
        }
        return TrebbleClientAPIHelper.getInstance().verifyMagicAuth.bind(TrebbleClientAPIHelper.getInstance());
    },

    _getVerifyEmailVerificationApi : function(){
        if(this.verifyEmailVerificationApi){
            return this.verifyEmailVerificationApi;
        }
        return TrebbleClientAPIHelper.getInstance().verifyEmailVerification.bind(TrebbleClientAPIHelper.getInstance());
    },

    _promptForPendingEmailVerification : function(challenge){
        $.mobile.loading("hide");
        return new RSVP.Promise((function(resolve, reject){
            this._pendingInlineAuthChallenge = {
                mode: INLINE_AUTH_MODES.EMAIL_VERIFICATION,
                pendingAuthenticationToken: challenge ? challenge.pendingAuthenticationToken : null,
                resolve: resolve,
                reject: reject,
            };
            if(this.view){
                this.view.openInlineAuthFlow(INLINE_AUTH_MODES.EMAIL_VERIFICATION, {
                    email: challenge && challenge.email ? challenge.email : "",
                    pendingAuthenticationToken: challenge ? challenge.pendingAuthenticationToken : null,
                });
            }
        }).bind(this));
    },

    onLoginWithMagicCodeBtnTapped : function(){
        const loginIdentifier = this.view && this.view.usernameField$el ? this.view.usernameField$el.val() : "";
        const defaultEmail = this.validateEmail(loginIdentifier) ? loginIdentifier.trim().toLowerCase() : "";
        if(this.view){
            this.view.openInlineAuthFlow(INLINE_AUTH_MODES.MAGIC_EMAIL, {
                email: defaultEmail,
            });
        }
    },

    onInlineAuthSubmit : function(data){
        if(!data || !data.mode){
            return RSVP.Promise.resolve(false);
        }

        if(data.mode === INLINE_AUTH_MODES.MAGIC_EMAIL){
            if(!this.validateEmail(data.email)){
                if(this.view){
                    this.view.setInlineAuthError(window.getI18n(ti18n, "PLEASE_ENTER_A_VALID_EMAIL"));
                }
                return RSVP.Promise.resolve(false);
            }

            $.mobile.loading("show");
            return this._getStartMagicAuthApi()(data.email).then((function(){
                if(this.view){
                    this.view.openInlineAuthFlow(INLINE_AUTH_MODES.MAGIC_CODE, {
                        email: data.email,
                    });
                }
            }).bind(this)).catch((function(error){
                if(this.view){
                    const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
                    this.view.setInlineAuthError(resolvedErrorMessage || window.getI18n(ti18n, "MAGIC_CODE_SEND_FAILED"));
                }
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        if(data.mode === INLINE_AUTH_MODES.SSO_EMAIL){
            if(!this.validateEmail(data.email)){
                if(this.view){
                    this.view.setInlineAuthError(window.getI18n(ti18n, "ORGANIZATION_LOGIN_REQUIRES_WORK_EMAIL"));
                }
                return RSVP.Promise.resolve(false);
            }

            return this.startOrganizationLogin(data.email).then((function(result){
                if(result && this.view){
                    this.view.closeInlineAuthFlow();
                }
                return result;
            }).bind(this));
        }

        if(data.mode === INLINE_AUTH_MODES.MAGIC_CODE){
            return this._completeMagicCodeLogin(data.email, data.code);
        }

        if(data.mode === INLINE_AUTH_MODES.RESET_PASSWORD){
            return this.sendRecoveryPasswordEmail(data.email);
        }

        if(data.mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            if(!data.code){
                if(this.view){
                    this.view.setInlineAuthError(window.getI18n(ti18n, "MAGIC_CODE_CODE_REQUIRED"));
                }
                return RSVP.Promise.resolve(false);
            }
            $.mobile.loading("show");
            return this._getVerifyEmailVerificationApi()(data.pendingAuthenticationToken, data.code).then((function(loginSuccessfull){
                if(loginSuccessfull){
                    const pendingChallenge = this._pendingInlineAuthChallenge;
                    this._pendingInlineAuthChallenge = null;
                    if(this.view){
                        this.view.closeInlineAuthFlow();
                    }
                    if(pendingChallenge && pendingChallenge.resolve){
                        pendingChallenge.resolve(true);
                    }
                }else{
                    throw window.getI18n(ti18n, "LOGIN_FAILED");
                }
            }).bind(this)).catch((function(error){
                if(this.view){
                    const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
                    this.view.setInlineAuthError(resolvedErrorMessage || window.getI18n(ti18n, "EMAIL_VERIFICATION_VERIFY_FAILED"));
                }
            }).bind(this)).finally((function(){
                $.mobile.loading("hide");
            }).bind(this));
        }

        return RSVP.Promise.resolve(false);
    },

    onInlineAuthSecondaryAction : function(data){
        if(!data || !data.mode){
            return;
        }

        if(data.mode === INLINE_AUTH_MODES.MAGIC_CODE){
            if(this.view){
                this.view.openInlineAuthFlow(INLINE_AUTH_MODES.MAGIC_EMAIL, {
                    email: data.email,
                });
            }
            return;
        }

        if(data.mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            const pendingChallenge = this._pendingInlineAuthChallenge;
            this._pendingInlineAuthChallenge = null;
            if(this.view){
                this.view.closeInlineAuthFlow();
            }
            if(pendingChallenge && pendingChallenge.reject){
                pendingChallenge.reject("handled");
            }
            return;
        }

        if(this.view){
            this.view.closeInlineAuthFlow();
        }
    },

    _completeMagicCodeLogin : function(email, code){
        $.mobile.loading("show");
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        return this._getVerifyMagicAuthApi()(email, code).then((function(loginSuccessfull){
            if(loginSuccessfull){
                this._trackSuccessfulLogin('email_code');
                return this._finalizeSuccessfulAuthentication(true, {
                    closeInlineAuthFlow: true,
                });
            }else{
                throw window.getI18n(ti18n, "LOGIN_FAILED");
            }
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            if(this.view){
                const resolvedErrorMessage = Utils.getInstance().getErrorMessageFromObject(error);
                this.view.setInlineAuthError(resolvedErrorMessage || window.getI18n(ti18n, "MAGIC_CODE_VERIFY_FAILED"));
            }
        }).bind(this));
    },




    showSignupWithoutUsingRouter : function(){

        if(this.view){
            this.view.setRemoveOnHide(false);
        }

        this._signupPageOpened = true;
        const signupAsShortcastCreator = window.trebble.launchFromEditorLandingPage || this.forceSignUpAsCreator;
        const defaultSignupIntent = this._getSignupFlowDefaultIntent();
        const controllerParams = {};
        controllerParams.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
        controllerParams.signupApi = this.signupApi;
        controllerParams.signupWithFacebookApi = this.signupWithFacebookApi;
        controllerParams.signupWithGoogleApi = this.signupWithGoogleApi;
        controllerParams.signupWithAppleApi = this.signupWithAppleApi;
        controllerParams.signupAsShortcastCreator = signupAsShortcastCreator;
        controllerParams.defaultSignupIntent = defaultSignupIntent;
        controllerParams.onSignupSuccessfullyCompleted = this._onSignupPageClosed.bind(this);
        let signUpController  = null;
        const SignupControlledLoaded  = SignUpController;
        const pageId = AUTH_SURFACE_PAGE_IDS.NEW_SIGNUP;
        $.mobile.loading("show");
         //window.trebble.helper.requirePromise(signUpControllerToLoad).then((function(SignupControlledLoaded){
            signUpController = new SignupControlledLoaded(controllerParams);
            return signUpController.buildModelAndRenderView().then((function(){
            $.mobile.loading("hide");
            return window.trebble.pageContainerReadyPromise;
        }).bind(this)).then((function(){
            $('body').append(signUpController.getView().$el);
            signUpController.getView().$el.trigger("pageAppendedToBody")
            signUpController.getView().$el.attr("appendedToBody", true);
            $.mobile.changePage("#"+pageId,{changeHash : true});	
            const signupPageUrl =  (window.location.protocol == "http:"||window.location.protocol == "https:")? location.origin + window.getAppBaseUrl() + "#"+pageId :window.getBaseUrlWithoutEndSlash()+"#"+pageId;
            
            if(history.pushState) {
                history.pushState(null, null, "/"+ pageId);
            }else{
                window.location.assign(signupPageUrl );
            }
            let popped = ('state' in window.history && window.history.state !== null), initialURL = location.href;

            $(document).ready((function(){

                this.self.onBackButtonPressHanlder = (function(){
                    const initialPop = !popped && location.href == initialURL;
                    popped = true;
                    if (initialPop) {
                        //The page has not finish loading and this might be a wrong event sent by Chrome so ignore see https://github.com/vojtech-dobes/nette.ajax.js/issues/73
                        return;
                    }

                    $.mobile.back();
                    window.removeEventListener('popstate', this.onBackButtonPressHanlder);

                }).bind(this.self);
                window.addEventListener('popstate', this.self.onBackButtonPressHanlder);
            }).bind(this));

            $.mobile.resetActivePageHeight();
        }).bind({/*"signUpController": signUpController,*/"self": this})).catch(function(error){
$.mobile.loading("hide");
console.error("An error occured while showing Login Page.Error:"+ error,error);
window.alertErrorMessage(error);
});
    },

    showSignup : function(){
        if(this.view){
            this.view.setRemoveOnHide(false);
        }
       this._signupPageOpened = true;
       // return window.trebble.helper.requirePromise(["services/PersistentModels"]).then((function(PersistentModels){
            if(PersistentModels.getInstance().getRouter()){
                const signupAsShortcastCreator = !this.isUserNotAllowedToSignupAsCreator() && (window.trebble.launchFromEditorLandingPage || this.forceSignUpAsCreator);
                const defaultSignupIntent = this._getSignupFlowDefaultIntent();
                return PersistentModels.getInstance().getRouter().showNewSignupPage(null, null, true , this.signupApi, this.signupWithFacebookApi,this.signupWithGoogleApi,this.signupWithAppleApi, this._onSignupPageClosed.bind(this), this.isUserpreviouslyLoggedInAsGuest, signupAsShortcastCreator, defaultSignupIntent);
            }else{
                return this.showSignupWithoutUsingRouter();
            }
       /* }).bind(this)).catch(function(error){
            console.error("An error occured while showing Login Page.Error:"+ error,error);
            window.alertErrorMessage(error);
});*/

    },

    _onSignupPageClosed  : function(data){
        this._signupPageOpened = false;
        if(data){
            let loginPromise =  null;
            if(data.authenticatedSessionReady){
                loginPromise = this._finalizeSuccessfulAuthentication(data, {
                    treatAsSignupCompletion: true,
                });
            }else if("Facebook" === data.externalProfileSignup){
                loginPromise = this.doLoginWithFacebook(data.facebookAccessToken);
            }else{
                if("Google" === data.externalProfileSignup){
                    loginPromise = this.doLoginWithGoogle(data.googleUser);
                }else{
                    if("Apple" === data.externalProfileSignup){
                        loginPromise = this.doLoginWithApple(data.appleAccessToken);
                    }else{

                        loginPromise = this.doLogin(data);
                    }
                }
            }
            if(loginPromise && loginPromise.then){
                loginPromise.then((function(){
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Onboarding", "SignupCompletedSentAfterLogin", "Sign-up Completed Sent After Login");
                    }
                    FacebookEventTrackingHelper.getInstance().trackRegistration(false, false); 
                }).bind(this))
            }
        }else{
            this._showLoginPageView();
        }

    },




    onViewRemovedFromDocument : function(){
        if(this._skipLoginCancellationOnNextViewRemoval){
            this._skipLoginCancellationOnNextViewRemoval = false;
            return;
        }
        if(!this._signupPageOpened && this.onLoginSuccessfullyCompleted){
            this.onLoginSuccessfullyCompleted(false);
        }
    },

    onContinueAsGuessBtnTapped : function(){
        if(this.view){
            this.view.setRemoveOnHide(true);
        }
        $.mobile.loading("show");
        this.loginAsGuestApi().then((function(loginResult){
            if(loginResult){
                return this._finalizeSuccessfulAuthentication(loginResult);
            }else{
                throw window.getI18n(ti18n, "LOGIN_FAILED");
            }
        }).bind(this)).then((function(){
            $.mobile.loading("hide");
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            window.alertErrorMessage(error);
        }).bind(this));
    },

    showFeaturesPage : function(){
        return new RSVP.Promise((function(resolve, reject) {
            try{
                const options = {};
                options.onFeaturePageClosedHandler = function(){ resolve()};
                let featurePageController = null;
                return window.trebble.helper.requirePromise(["controllers/featurePage/FeaturePageController"]).then((function(FeaturePageController){
                    featurePageController = new FeaturePageController(options);
                    return featurePageController.buildModelAndRenderView();
                }).bind(this)).then((function(){
                    return window.trebble.pageContainerReadyPromise;
                }).bind(this)).then((function(){
                    $('body').append(featurePageController.getView().$el);
                    $.mobile.changePage("#featurePage",{changeHash:true});
                    $.mobile.resetActivePageHeight();
                    document.body.style["background-color"]="rgba(17,17,17,1)";
                    document.body.style["border-color"]="rgba(17,17,17,1)";
                    $("#loadingBoxWidget").css("display","none");
                    if(navigator.splashscreen){
                        navigator.splashscreen.hide();
                    }
                }).bind({/*"featurePageController": featurePageController,*/ "router": this})).catch(function(error){
                    document.body.style["background-color"]="rgba(17,17,17,1)";
                    document.body.style["border-color"]="rgba(17,17,17,1)";
                    $("#loadingBoxWidget").css("display","none");
                    if(navigator.splashscreen){
                        navigator.splashscreen.hide();
                    }
                    console.error("An error occured while displaying feature Page.Error:"+ error);
                    reject(error);
                });
            }catch(error){
                reject(error);
            }
        }).bind(this));

},

isPlayerGettingOpened : function(){
return location.hash && (location.hash.indexOf("#player")  == 0 ||  location.hash.indexOf("#p/")  == 0 ) ||  window.getPathNameWithoutHtmlPage() && (window.getPathNameWithoutHtmlPage().indexOf("/player")  == 0 ||  window.getPathNameWithoutHtmlPage().indexOf("/p/")  == 0 );
},

openRequesInvitePage : function(){
const openedWindow = window.open("https://trebble.typeform.com/to/JXo8tX", "_blank");
if((!openedWindow || openedWindow.closed || typeof openedWindow.closed=='undefined') && !window.waitForCordovaToLoad){
window.alertErrorMessage(window.getI18n(ti18n, "PLEASE_ALLOW_POPUPS_FOR_TREBBLE"));
}else{
if(openedWindow.focus){
    openedWindow.focus();
}
}

},

onForgotPasswordLinkClicked : function(){
const loginIdentifier = this.view && this.view.usernameField$el ? this.view.usernameField$el.val() : "";
const defaultEmail = this.validateEmail(loginIdentifier) ? loginIdentifier.trim().toLowerCase() : "";
if(this.view){
    this.view.openInlineAuthFlow(INLINE_AUTH_MODES.RESET_PASSWORD, {
        email: defaultEmail,
    });
}
},

validateEmail : function(email) {
const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
return re.test(email? email.trim(): email);
},

sendRecoveryPasswordEmail : function(email){

$.mobile.loading("show");
return TrebbleClientAPIHelper.getInstance().sendRecoveryPasswordEmail(email).then((function(){
//window.alertSuccessMessage("A link to reset your password has been sent to "+ email);
window.alertSuccessMessage(window.getI18n(ti18n, "A_LINK_TO_RESET_PASSWORD_SENT"));
if(this.view){
    this.view.closeInlineAuthFlow();
}
$.mobile.loading("hide");
}).bind(this)).catch((function(error){
$.mobile.loading("hide");
const errorMessage = error? error: window.getI18n(ti18n, "SOMETHING_WENT_WRONG_SENDING_PASSWORD_RESET_LINK");
if(this.view && this.view.getInlineAuthData && this.view.getInlineAuthData().mode === INLINE_AUTH_MODES.RESET_PASSWORD){
    this.view.setInlineAuthError(errorMessage);
}else{
    window.alertErrorMessage(errorMessage);
}
}).bind(this));


},

onViewRemoved:function(){
this.stopListening();
},

shouldJumpToSignupPage : function(){
try{
const searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(location.search));
if(searchParams && searchParams.get("jumpToSignup") === "true"){
    searchParams.set("jumpToSignup", "false");
    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
    return true;
}
}catch(error){
console.error(error);
}
return false;
},

_showLoginPageView : function(){
return new RSVP.Promise((function(resolve, reject) {
try {
    if(
        Utils.getInstance().isBrowserHostedAuthEnvironment() &&
        !this.showAsPopup &&
        Utils.getInstance().isTokenValid() &&
        LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor()
    ){
        this._runLoginSuccessCallback({
            alreadyAuthenticated: true,
            preserveCurrentRoute: true,
        }).then(function(){
            resolve();
        }).catch(function(error){
            reject(error);
        });
        return;
    }
    if(DISABLE_FEATURE_PAGE || LocalStorageHelper.getInstance().isFirstApplicationLaunchDone() || (window.trebble.presetAccessCode != BUILT_IN_ACCESS_CODE_FOR_LISTENERS)|| $("body").hasClass("embedded") || window.trebble.entryPointUrlHashLoadedPlayerQueue || window.trebble.isEmbededLoginInPage){
        const options = {};
        options.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
        options.showAsPopup = this.showAsPopup;
        options.doNotAllowGuestLogin = this.doNotAllowGuestLogin;
        options.showOrganizationLogin = true;
        options.clickingOnSocialLoginWillSignupAutomatically =  this.createUserAccountOnLoginIfUserDoesntExist();
        this.view = new LoginPageViewNew(options);
        /*if(this.isPlayerGettingOpened()){
            resolve();
        }else{*/
            this.view.render().then((function(){
                this.listenTo(this.view, "loginBtnTapped", this.doLogin.bind(this));
                this.listenTo(this.view, "signupButtonTapped", this.showSignup.bind(this));
                this.listenTo(this.view, "requestInviteBtnTapped", this.openRequesInvitePage);
                this.listenTo(this.view, "loginWithFacebookBtnTapped", this.doLoginWithFacebook);
                this.listenTo(this.view, "loginWithAppleBtnTapped", this.doLoginWithApple);
                this.listenTo(this.view, "loginWithGoogleBtnSuccess", this.doLoginWithGoogle);
                this.listenTo(this.view, "loginWithGoogleBtnFailed",this.onGoogleLoginFailed);
                this.listenTo(this.view, "loginWithMagicCodeBtnTapped", this.onLoginWithMagicCodeBtnTapped);
                this.listenTo(this.view, "organizationLoginBtnTapped", this.startOrganizationLogin);
                this.listenTo(this.view, "inlineAuthSubmit", this.onInlineAuthSubmit);
                this.listenTo(this.view, "inlineAuthSecondaryAction", this.onInlineAuthSecondaryAction);
                this.listenTo(this.view, "removedFromPage", this.onViewRemovedFromDocument);
                this.listenTo(this.view, "continueAsGuessBtnTapped", this.onContinueAsGuessBtnTapped);
                this.listenTo(this.view, "forgotPasswordLinkClicked", this.onForgotPasswordLinkClicked);
                this.listenTo(this.view, "remove", this.onViewRemoved.bind(this));
                resolve();
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("Onboarding", "LoginPageOpened", "Login Page Opened");
                } 
                if(this._successSignupData){
                    this._onSignupPageClosed(this._successSignupData);
                }
                if(this.shouldJumpToSignupPage()){
                    this.showSignup();
                }
            }).bind(this)).catch(reject);
//}

}else{
this.showFeaturesPage().then((function(){
const options = {};
options.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
options.showAsPopup = this.showAsPopup;
options.doNotAllowGuestLogin = this.doNotAllowGuestLogin;
options.showOrganizationLogin = true;
options.clickingOnSocialLoginWillSignupAutomatically =  this.createUserAccountOnLoginIfUserDoesntExist();
this.view = new LoginPageViewNew(options);
this.view.render();
this.listenTo(this.view, "loginBtnTapped", this.doLogin.bind(this));
this.listenTo(this.view, "signupButtonTapped", this.showSignup.bind(this));
this.listenTo(this.view, "requestInviteBtnTapped", this.openRequesInvitePage);
this.listenTo(this.view, "loginWithFacebookBtnTapped", this.doLoginWithFacebook);
this.listenTo(this.view, "loginWithAppleBtnTapped", this.doLoginWithApple);
this.listenTo(this.view, "loginWithGoogleBtnSuccess", this.doLoginWithGoogle);
this.listenTo(this.view, "loginWithGoogleBtnFailed",this.onGoogleLoginFailed);
this.listenTo(this.view, "loginWithMagicCodeBtnTapped", this.onLoginWithMagicCodeBtnTapped);
this.listenTo(this.view, "organizationLoginBtnTapped", this.startOrganizationLogin);
this.listenTo(this.view, "inlineAuthSubmit", this.onInlineAuthSubmit);
this.listenTo(this.view, "inlineAuthSecondaryAction", this.onInlineAuthSecondaryAction);
this.listenTo(this.view, "removedFromPage", this.onViewRemovedFromDocument);
this.listenTo(this.view, "continueAsGuessBtnTapped", this.onContinueAsGuessBtnTapped);
this.listenTo(this.view, "forgotPasswordLinkClicked", this.onForgotPasswordLinkClicked);
this.listenTo(this.view, "remove", this.onViewRemoved.bind(this));

resolve();
if(window.trebbleAnalyticsHelper){
    window.trebbleAnalyticsHelper.trackEvent("Onboarding", "LoginPageOpened", "Login Page Opened");
} 
if(this.shouldJumpToSignupPage()){
    this.showSignup();
}
}).bind(this)).catch(reject);
}

return;
} catch (error) {
reject(error);
}

}).bind(this));
},


buildModelAndRenderView : function() {
return this._showLoginPageView();

}

});

export default LoginController;
